module.exports = __webpack_public_path__ + "img/img_font.22995bbc.png";